import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { Button, Typography } from '@mui/material';
import Grid from '@mui/material/GridLegacy';

import { $tk } from 'utils/appTranslationKey';
import { ErrorIcon } from 'components/GenericErrorPage/icons/ErrorIcon';

interface GenericErrorPageProps {
  pageHeight?: string;
}

export function GenericErrorPage(props: GenericErrorPageProps) {
  const { formatMessage } = useIntl();
  const strings = useMemo(
    () => ({
      title: formatMessage({ id: $tk.components.GenericErrorPage.title }),
      text: formatMessage({ id: $tk.components.GenericErrorPage.text }),
      buttonText: formatMessage({ id: $tk.components.GenericErrorPage.buttonText }),
    }),
    [formatMessage],
  );

  const actions = useMemo(
    () => ({
      onTryAgain: () => {
        window.location.reload();
      },
    }),
    [],
  );
  const handleOnTryAgain = useCallback(() => {
    actions.onTryAgain();
  }, [actions]);

  // TODO: FDPE-3569 - adjust Typography variants after updating UI elements according to Kalep (FDPE-3497 Figma design)
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      wrap="nowrap"
      spacing={4}
      sx={{ height: props.pageHeight ?? '100vh' }}
    >
      <Grid item>
        <ErrorIcon />
      </Grid>
      <Grid item>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Typography variant="h5" align="center">
              {strings.title}
            </Typography>
          </Grid>
          <Grid item>
            <Typography align="center" maxWidth={424}>
              {strings.text}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Button variant="contained" onClick={handleOnTryAgain}>
          {strings.buttonText}
        </Button>
      </Grid>
    </Grid>
  );
}
